export default {
  title: 'Custom print products',
  fields: {
    name: 'Name',
    format: 'Product type',
  },
  buttons: {
    upload_product: 'Start upload process',
    preview: 'Preview',
    edit: 'Edit',
  },
};
